import { V3Record } from 'data/helpers/V3Record.js'

export const AppCode = V3Record('appCode', {
  parentId: null,
  parentType: null,
  createdAt: null,
  code: null,
  active: null,
  accessLimit: null,
  timesUsed: null,
  guideCode: null
})
